var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 150
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFDF8",
    fillRule: "evenodd",
    d: "M226.932 0v149.14H12.418L4.47 132.829C-6.208 110.917 2.9 84.499 24.81 73.82a44.135 44.135 0 014.238-1.798L226.932 0z"
  })));
}

export default SvgShapeRectangle;